import { create } from 'zustand'

type SelectedScadaTagsState = {
	tags: HTMLDivElement[];
  addTag: (tag: HTMLDivElement) => void;
  removeTag: (tag: HTMLDivElement) => void;
  clear: () => void;
};

const useSelectedScadaTagsStore = create<SelectedScadaTagsState>()(
			set => (
        {
          tags: [],
          addTag: (tag) => set(state => ({ tags: [...state.tags, tag] })),
          removeTag: (tag) => set(state => ({ tags: state.tags.filter(t => t !== tag) })),
          clear: () => set(() => ({ tags: [] })),
        }
      ),
);

export default useSelectedScadaTagsStore;